import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import router from '@/router'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(VueToast)

export const helper = {
  catchHandler: (err) => {
    console.log(err.response)
    Vue.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
    router.push('/login')
  },
  isObject (val, toEdit) {
    if (toEdit && (val === 'null' || val === '')) { return true }
    return (typeof val === 'object')
  }
}



// WEBPACK FOOTER //
// ./src/helper/helper.js